// settingsApi.js
const API_SETTINGS = {
    getBaseUrl(subdomain) {
            return `https://api.duotetra.quest/${subdomain}`;
    },
};

export default API_SETTINGS;
